"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingSolution = void 0;
var ListingSolution;
(function (ListingSolution) {
    ListingSolution["CHANNEL_ADVISOR"] = "channel_advisor";
    ListingSolution["GEEKSELLER"] = "geekseller";
    ListingSolution["LISTINGMIRROR"] = "listingmirror";
    ListingSolution["SELLBRITE"] = "sellbrite";
    ListingSolution["SELLERACTIVE"] = "selleractive";
    ListingSolution["SELLERCLOUD"] = "sellercloud";
    ListingSolution["SHOPIFY"] = "shopify";
    ListingSolution["WALMARTDIRECT"] = "walmartdirect";
    ListingSolution["ZENTAIL"] = "zentail";
    ListingSolution["WISH"] = "wish";
    ListingSolution["LINNWORKS"] = "linnworks";
    ListingSolution["EBAY"] = "ebay";
    ListingSolution["ACENDA"] = "acenda";
    ListingSolution["ECOMDASH"] = "ecomdash";
    ListingSolution["SKUBANA"] = "skubana";
    ListingSolution["PIPE17"] = "pipe17";
    ListingSolution["SELLERCHAMP"] = "sellerchamp";
    ListingSolution["BIGCOMMERCE"] = "bigcommerce";
    ListingSolution["AMAZON"] = "amazon";
    ListingSolution["ARTEZA"] = "arteza";
    ListingSolution["GOOGLE"] = "google";
    ListingSolution["FACEBOOK"] = "facebook";
    ListingSolution["MOBILITYECOMMERCE"] = "mobilityecommerce";
    ListingSolution["STOREAUTOMATOR"] = "storeautomator";
    ListingSolution["SOLIDCOMMERCE"] = "solidcommerce";
    ListingSolution["JCPENNEY"] = "jcpenney";
    ListingSolution["WOOCOMMERCE"] = "woocommerce";
    ListingSolution["ETSY"] = "etsy";
    ListingSolution["SKUPREME"] = "skupreme";
    ListingSolution["FLIEBER"] = "flieber";
    ListingSolution["DELIVERR_API"] = "deliverr_api";
    ListingSolution["MIRAKL"] = "mirakl";
    ListingSolution["SHOPIFY_LOGISTICS"] = "shopify_logistics";
    ListingSolution["SHOPIFY_V2"] = "shopify_v2";
    ListingSolution["SHOPIFY_V3"] = "shopify_v3";
})(ListingSolution = exports.ListingSolution || (exports.ListingSolution = {}));
//# sourceMappingURL=ListingSolution.js.map